
import areasReducer from "services/area/area.reducer";
import membersReducer from "services/members/members.reducer";
import familyReducer from "services/family/family.reducer";
import errorsReducer from "services/errors/errors.reducer";
import filesReducer from "services/file/file.reducer";
import churchesReducer from "services/churches/churches.reducer";
import modalsReducer from "services/modals/modals.reducer";
import fileUploaderReducer from "services/filesUploader/filesUploader.reducer";
import loaderReducer from "services/loader/loader.reducer";
import appInfoReducer from "services/appInfo/appInfo.reducer";
import filtersReducer from "services/filters/filters.reducer";
import liturgiesReducer from "services/liturgy/liturgy.reducer";
import profileReducer from "services/profile/profile.reducer";
import marriageNocReducer from "services/marriageNoc/marriageNoc.reducer";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";
import createSagaMiddleware from "redux-saga";
import rootSaga from "services/root.sagas";
import {composeWithDevTools} from "@redux-devtools/extension";

const sagaMiddleware = createSagaMiddleware();

const {
    createReduxHistory,
    routerMiddleware,
    routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

const appReducer = combineReducers({
    areas: areasReducer,
    members: membersReducer,
    family: familyReducer,
    errors: errorsReducer,
    files: filesReducer,
    churches: churchesReducer,
    modals: modalsReducer,
    fileUploader: fileUploaderReducer,
    loader: loaderReducer,
    appInfo: appInfoReducer,
    filters: filtersReducer,
    liturgies: liturgiesReducer,
    profile: profileReducer,
    marriageNoc: marriageNocReducer,
    router: routerReducer
});

export const store = createStore(
  appReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
    applyMiddleware(routerMiddleware)
  )
);

sagaMiddleware.run(rootSaga);

export const history = createReduxHistory(store);
